var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "oldNaviDots",
      on: {
        mouseenter: function($event) {
          _vm.active = _vm.isTouch ? _vm.active : true
        },
        mouseleave: function($event) {
          _vm.active = _vm.isTouch ? _vm.active : false
        },
        click: function($event) {
          _vm.active = _vm.isTouch ? !_vm.active : _vm.active
        }
      }
    },
    [
      _c("span", { staticClass: "icon ellipsis-v" }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.active,
            expression: "active"
          }
        ],
        staticClass: "arrowTop"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active,
              expression: "active"
            }
          ],
          staticClass: "oldEditMenuContainer"
        },
        [
          _vm.canEdit
            ? _c("div", [
                _c("a", { on: { click: _vm.editUserContent } }, [
                  _vm._v("Bearbeiten")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.canDelete
            ? _c("div", [
                _c("a", { on: { click: _vm.deleteUserContentConfirmation } }, [
                  _vm._v("Löschen")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.canReply
            ? _c("div", [
                _c("a", { on: { click: _vm.replyUserContent } }, [
                  _vm._v("Antworten")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.canCopy
            ? _c("div", [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "clipboard",
                        rawName: "v-clipboard",
                        value: _vm.contentkey,
                        expression: "contentkey"
                      }
                    ],
                    on: {
                      success: _vm.handleCopySuccess,
                      error: _vm.handleCopyError
                    }
                  },
                  [_vm._v("Kopieren")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "modalDialog",
          staticClass: "modal fade",
          attrs: { tabindex: "-1", role: "dialog" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog old-modal-dialog",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm._v(
                    "\n                    Möchten Sie diesen Inhalt wirklich löschen?\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Nein")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.deleteUserContent }
                    },
                    [_vm._v("Ja")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Bestätigung")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e65b7dfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e65b7dfe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserContentEditPanel.vue
// module id = 489
// module chunks = 2